import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import "./settings.css";
import SideBar from "./Components/SideBar/SideBar";
import ReferralsManager from "./Components/ManageReferrals/ReferralsManager";
import { useSnackBar } from "../../../../../hooks/useSnackBar";

const Referrals = () => {
  const user = useSelector((state) => state.user);
  const setSnack = useSnackBar();

  // Referrals belong to the Shipper parent account only. The backend rejects
  // other roles but not helpers (they share the parent's role), so helpers
  // are kept out here.
  if (user?.role !== "Shipper" || user?.parent_id) {
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <div className="parent_wraper">
      <SideBar active="5_0" />
      <div className="dash_table_wrapper">
        <ReferralsManager setSnack={setSnack} />
      </div>
    </div>
  );
};

export default Referrals;
